import api from '@/api';
import {
  BoschCompanyConfiguration,
  BoschCompanyConfigurationRequest,
  BoschJobCardResponse,
} from './Bosch.type';

const path = '/workorder/v1/Bosch';

export default {
  async createJobCard(complementId: number) {
    const result = (await api.post(`${path}/job-cards`, {
      complementId,
    })) as unknown;
    return result as BoschJobCardResponse;
  },

  async downloadReport(complementId: number) {
    const result = (await api.getReport(
      `${path}/${complementId}/bosch-report`,
      null,
    )) as unknown;
    return result as Blob;
  },

  async createConfig(payload: BoschCompanyConfigurationRequest) {
    const result = (await api.post(
      `${path}/company-configuration`,
      payload,
    )) as unknown;
    return result as void;
  },

  async updateConfig(payload: BoschCompanyConfigurationRequest) {
    const result = (await api.put(
      `${path}/company-configuration`,
      payload,
      null,
    )) as unknown;
    return result as void;
  },

  async detailConfig(companyId?: number) {
    const result = (await api.get(
      `${path}/company-configuration/${companyId}`,
      null,
    )) as unknown;
    return result as BoschCompanyConfiguration;
  },

  async removeConfig(companyId?: number) {
    const result = (await api.remove(
      `${path}/company-configuration/${companyId}`,
      {},
      null,
    )) as unknown;
    return result as void;
  },
};
